import { render, staticRenderFns } from "./TransferCarDetail.vue?vue&type=template&id=f2e591c2&"
import script from "./TransferCarDetail.vue?vue&type=script&lang=js&"
export * from "./TransferCarDetail.vue?vue&type=script&lang=js&"
import style0 from "./TransferCarDetail.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports